/* eslint-disable */
// => https://gitlab.com/gitlab-org/gitlab-ui/-/blob/main/src/components/base/filtered_search/filtered_search.vue
// Copyright GitLab B.V.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
import { GlDropdownItem } from '@gitlab/ui';
import { ApckGlFilteredSearchSuggestionList } from './apck_glfiltered_search_suggestion_list';

export const ApckGlFilteredSearchSuggestion =  {
  name: 'GlFilteredSearchSuggestion',
  components: {
    GlDropdownItem,
    ApckGlFilteredSearchSuggestionList
  },
  inject: ['apckFilteredSearchSuggestionListInstance'],
  inheritAttrs: false,
  props: {
    /**
     * Value that will be emitted if this suggestion is selected.
     */
    value: {
      required: true,
      validator: () => true,
    },
  },
  computed: {
    isActive() {
      return this.apckFilteredSearchSuggestionListInstance.activeItem === this;
    },
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        window.requestAnimationFrame(() => {
          this.$refs.item?.$el?.scrollIntoView({ block: 'nearest', inline: 'end' });
        });
      }
    },
  },
  created() {
    this.apckFilteredSearchSuggestionListInstance.register(this);
  },
  beforeDestroy() {
    this.apckFilteredSearchSuggestionListInstance.unregister(this);
  },
  methods: {
    emitValue() {
      // We use href argument for gl-dropdown-item to use <a> instead of <button>
      // due to https://bugs.webkit.org/show_bug.cgi?id=22261
      this.apckFilteredSearchSuggestionListInstance.$emit('suggestion', this.value);
    },
  },

  template: `
  <gl-dropdown-item
    ref="item"
    class="gl-filtered-search-suggestion"
    data-testid="filtered-search-suggestion"
    :class="{ 'gl-filtered-search-suggestion-active': isActive }"
    tabindex="-1"
    v-bind="$attrs"
    href="#"
    @mousedown.native.prevent="emitValue"
  >
    <!-- @slot The suggestion content. -->
    <slot></slot>
  </gl-dropdown-item>
  `
};
